import { userService } from '@/services'

let initialState = {
  acceptAvvDateTime: null,
  address: null,
  addressAddition: null,
  alwaysAcceptAVV: null,
  city: null,
  companyName: null,
  country: null,
  creationTime: null,
  customerNumber: null,
  onsCustomerNo: null,
  email: null,
  firstName: null,
  lastName: null,
  phoneNumber: null,
  salutation: null,
  taxId: null,
  zipCode: null
}

export default {
  state: () => initialState,
  mutations: {
    SET_USER_PROFILE(state, userProfile) {
      Object.keys(state).map(function(key) {
        state[key] = userProfile[key]
      })
    },
    SET_ALWAYS_ACCEPT_AVV(state, responseAlwaysAcceptAVV) {
      state.alwaysAcceptAVV = responseAlwaysAcceptAVV.alwaysAcceptAVV
      state.acceptAvvDateTime = responseAlwaysAcceptAVV.acceptAvvDateTime
    },
    RESET_PROFILE(state) {
      const s = initialState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    }
  },
  actions: {
    async saveAlwaysAcceptAVV({ commit }) {
      return new Promise(async (resolve, reject) => {
        await userService
          .saveUserProfile({ alwaysAcceptAVV: true })
          .then(async function(response) {
            commit('SET_ALWAYS_ACCEPT_AVV', response)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    async getUserProfile({ dispatch }) {
      await userService
        .getUserProfile()
        .then(async function(response) {
          await dispatch('setUserProfile', response)
        })
        .catch(() => {})
    },
    async getAlwaysAcceptAVV({ dispatch }) {
      await userService.getUserProfile().then(async function(response) {
        await dispatch('setAlwaysAcceptAVV', response)
      })
    },
    setAlwaysAcceptAVV({ commit }, responseAlwaysAcceptAVV) {
      commit('SET_ALWAYS_ACCEPT_AVV', responseAlwaysAcceptAVV)
    },
    setUserProfile({ commit }, userProfile) {
      commit('SET_USER_PROFILE', userProfile)
    },
    resetUserProfile({commit}) {
      commit('RESET_PROFILE')
    }
  },
  getters: {
    profile: state => {
      return state
    },
    greeting: state => {
      if (state.firstName && state.lastName)
        return state.firstName + ' ' + state.lastName
      return ''
    },
    initials: state => {
      return state.firstName && state.lastName
        ? state.firstName[0] + '' + state.lastName[0]
        : 'N/A'
    },
    hasEmptyProfile: state => {
      return !state.firstName ||
        !state.lastName ||
        !state.address ||
        !state.zipCode ||
        !state.city ||
        !state.customerNumber;
    },
    hasCustomerNumber: state => {
      return !!state.customerNumber
    },
    hasAVV: state => {
      return !!state.alwaysAcceptAVV;
    }
  }
}
